package com.dotdrives.web.pages.admin

import com.dotdrives.client.*
import com.dotdrives.controller.*
import com.dotdrives.model.*
import kotlinx.browser.window
import kotlinx.serialization.json.Json

class BrowserAdminStore:AdminOperationStore {
    private val json=Json { ignoreUnknownKeys=true }
    private fun key(userId:String)="dotdrives.admin.pending.$userId"
    override fun load(userId:String):PendingAdminOperation? = window.sessionStorage.getItem(key(userId))?.let { json.decodeFromString<PendingAdminOperation>(it) }
    override fun save(operation:PendingAdminOperation) { window.sessionStorage.setItem(key(operation.userId),json.encodeToString(operation)) }
    override fun clear(userId:String) { window.sessionStorage.removeItem(key(userId)) }
}
class BrowserAdminGateway(val client:AdminClient=AdminClient()):AdminGateway {
    override suspend fun identity():AdminIdentity {
        AuthClient().awaitInitialSession().session ?: error("Sign in with your invited account")
        return client.identity()
    }
    override suspend fun read(view:String,filter:kotlinx.serialization.json.JsonObject)=client.read(view,filter)
    override suspend fun mutate(operation:PendingAdminOperation):kotlinx.serialization.json.JsonObject {
        return if(operation.action.startsWith("billing.")||operation.action.startsWith("support.")) client.provider(operation.action,operation.orgId,operation.input,operation.reason,operation.operationId)
        else client.write(operation.action,operation.orgId,operation.input,operation.reason,operation.operationId)
    }
}
